<template>
  <div class="multi-video">
    <!-- <canvas ref="canvas" @click="onClick" :width="this.size.width" :height="this.size.height"></canvas> -->
    <!-- <div class="feedback">Frame: {{frameIndex}}</div> -->
    <!--:style="{maxWidth: cols*((size.height-80)/rows)+'px'}"-->
    <!-- NIDEA DE ESTE /3 pero parece que va... :D -->
    <div class="vid-list" :style="{gridTemplateColumns: `repeat(auto-fit, minmax(${size.height/3}px,1fr))`}">
      <div class="vid-wrapper" v-for="(v,i) in slicePlanes" 
        :key="v.id" 
        @click="()=>onClick(i)" 
        :class="{selected: currentSlice && currentSlice.id===v.id, unselected: currentSlice && currentSlice.id!==v.id }
        ">
        <video ref="vids" @loadeddata="onLoaded">
          <source :src="v.vid_src" type="video/mp4"/>
        </video>
      </div>
    </div>
    <loading-overlay v-if="!allLoaded"></loading-overlay>
  </div>
</template>

<script>
import * as THREE from 'three';
import widgetContent from '@/mixins/widgetContent'
import axios from 'axios'
import SuperGif from 'libgif'
import {createArray} from '@/utils'
import { throttle } from 'throttle-debounce';
import Api from '@/api'

if(!window.supergifsCache) window.supergifsCache = {}
let supergifsCache = window.supergifsCache

export default {
  props:['currentTime','currentSlice','config', 'currentPlayStatus', 'currentPlaySpeed', 'totalECGTime'],
  mixins: [widgetContent],
  data (){
    return {
      vidData: null,
      frameIndex: 0,
      dt: 0,
      // cols: 4,
      // rows: 2,
      // vid_width: 0,
      // vid_height: 0,
      hoveredFrame: 0,
      // renderState: null
      allLoaded: false,
      totalVideoDuration: 0
    }
  },
  mounted () {
    // let srcs = ['long2','long3']
    // let srcs
    // // if(this.config.direction === 'short') srcs = ['short_1','short_2','short_3','short_4','short_5','short_6']
    // // else srcs = ['long_1','long_2','long_3','long_4','long_5','long_6','long_7']
    // if(this.config.direction === 'short') srcs = ['sa_0','sa_1','sa_2']
    // else srcs = ['sa_0','sa_1','sa_2']

    // this.vidData = srcs.map((src,i)=>{
    //   return  {
    //     id: i,
    //     url: `static_data/case/videos/${src}.mp4`
    //   }
    // })
    // this.renderState = true
    this.sync()
    // let reqs = this.vidData.map((vd)=>{
    //   return this.loadSGif(vd.src)
    // })
    


    // Promise.all(reqs).then((responses)=>{
    //   this.offscreenCanvas = new OffscreenCanvas(0,0)
    //   let refGif = supergifsCache[this.vidData[0].src]
    //   let refCanvas = refGif.get_canvas()
    //   this.vid_width = refCanvas.width
    //   this.vid_height = refCanvas.height
    //   this.offscreenCanvas.width = this.vid_width*this.cols
    //   this.offscreenCanvas.height = this.vid_height*this.rows
    //   this.dt = (refGif.get_duration_ms()/1000)/refGif.get_frames().length
    //   this.drawGridFrame()
    // })
  },
  computed: {
    correctVideoSpeedFactor(){
      return this.totalVideoDuration && this.totalECGTime > 0 ? this.totalVideoDuration / this.totalECGTime : 1
    }
  },
  methods: {
    onLoaded(){
      // console.log(this.$refs.vids[0].readyState)
      
      this.allLoaded = this.$refs.vids.reduce((res,vid)=>{
      //   // console.log(vid.readyState)
         return res && vid.readyState > 0
       },true) 

      if (this.$refs.vids[0].readyState == 4) {
        this.totalVideoDuration = this.$refs.vids[0].duration
      }
      // console.log("all loaded: ",this.allLoaded)
    },
    onClick(idx){
      this._currentIndex = this._currentIndex !== idx ? idx : null

      if(this._currentIndex!==null) {
        let slicePlane = this.slicePlanes[idx]
        this.$emit('change-slice', slicePlane)
      } else {
        this.$emit('change-slice', null)
      }
    },
    playAll () {
      if(this.$refs.vids){
        this.$refs.vids.forEach((v)=>{
          v.playbackRate = this.currentPlaySpeed * this.correctVideoSpeedFactor
          v.loop = true
          v.play()
        })
      }
    },
    pauseAll () {
      if(this.$refs.vids){
        this.$refs.vids.forEach((v)=>{
          v.pause()
        })
      }
    },
    syncAll (){
      if(this.$refs.vids){
        this.$refs.vids.forEach((v)=>{
          v.currentTime = this.currentTime * this.correctVideoSpeedFactor
        })
      }
      //requestAnimationFrame(this.sync)
    },
    sync (){
      if(this.$refs.vids){
        this.$refs.vids.forEach((v)=>{
          v.currentTime = this.currentTime
        })
      }
      //requestAnimationFrame(this.sync)
    }
  },
  asyncComputed: {
    slicePlanes(){
      return Api.getPlanes(this.$store.state.paramsData).then(response=>{
        let view = this.config.direction==='short'?'sax':'lax'
        let planeDefs = response.filter((p)=>p.Type==='PLANE' && p.View===view)
        return Promise.all(planeDefs.map((p, index)=>{
          let normal = new THREE.Vector3(+p.Normal[0],+p.Normal[1],+p.Normal[2])
          let origin = new THREE.Vector3(+p.Point[0],+p.Point[1],+p.Point[2])

          let url = p.mp4
          
          //local data
          //url = `static_data/outputFile.mp4`
          //url = "static_data/mp4-orig/mp-edit/edit_run_name-SAX"+(index + 1)+".mp4"
          //url = "static_data/mp4-orig/run_name-SAX"+(index + 1)+".mp4"

          // let url = planeDefs[0].mp4
          
          return new Promise((res,rej)=>{
            var req = new XMLHttpRequest();
            req.open('GET', url, true);
            req.responseType = 'blob';

            req.onload = function() {
              // Onload is triggered even on 404
              // so we need to check the status code
              if (this.status === 200) {
                  var videoBlob = this.response;
                  var vid = URL.createObjectURL(videoBlob); // IE10+
                  
                  // Video is now downloaded
                  // and we can set it as source on the video element
                  res({id: p.Name, normal: normal, origin: origin, vid_src: vid})
              }
            }
            req.onerror = function() {
              // Error
              console.error("WTF, blob wrong")
              res({id: p.Name, normal: normal, origin: origin, vid_src: null})
            }

            req.send();
          })
          



          
        }))
      })
    }
  },
  watch: {
    // currentSlice () {
    //   this.drawGridFrame()
    // }
    allLoaded () {
      this.syncAll()
      if (this.allLoaded && this.currentPlayStatus == 'playing') {
        this.playAll()
      }
    },
    currentPlayStatus() {
      if(this.currentPlayStatus == 'playing'){
        this.playAll()
      } else {
        this.pauseAll()
        this.syncAll()
      }
    },
    currentTime () {
      if(this.currentPlayStatus != 'playing'){
        this.syncAll()
      }
    },
    currentPlaySpeed () {
      if(this.$refs.vids){
        this.$refs.vids.forEach((v)=>{
          v.playbackRate = this.currentPlaySpeed * this.correctVideoSpeedFactor
        })
      }
    }
 
  }
}
</script>

<style scoped lang="stylus">
.multi-video
  position relative
  margin auto
  display flex
  flex-direction: column;
  justify-content: center;
  .vid-list
    // display flex
    // flex-wrap wrap
    // justify-content: flex-start;
    display: grid;
    height 100%
    // grid-template-columns: repeat(auto-fit, minmax(100px,1fr))
    // margin auto
    .vid-wrapper
      border solid 1px #ddd
      flex 0 0 25%
      height auto
      display: flex;
      overflow hidden
      &:before 
        content:'';
        float:left;
        padding-top:100%;
      &.selected
        border solid 2px $radical-red
      &.unselected
        opacity 0.3
      video 
        width: 100%;
  // .feedback
  //   position absolute
  //   top: 0px
  //   font-weight bold
  //   color white
  //   margin: 5px;
</style>